import React, { FunctionComponent, useMemo, useState } from 'react';
import { CompositeDecorator, EditorState, Modifier } from 'draft-js';
import { detectUrl } from 'app/utils/stringMethods';

const Link = ({ entityKey, contentState, children }: any) => {
  const { url } = contentState.getEntity(entityKey).getData();

  return (
    <a
      style={{ color: 'blue', fontStyle: 'italic' }}
      href={url}
      target="_blank"
      rel="noreferrer"
    >
      {children}
    </a>
  );
};

const findLinkEntities = (
  contentBlock: any,
  callback: any,
  contentState: any
) => {
  contentBlock.findEntityRanges((character: any) => {
    const entityKey = character?.getEntity();

    return (
      entityKey !== null &&
      contentState?.getEntity(entityKey).getType() === 'LINK'
    );
  }, callback);
};

export const createLinkDecorator: any = () =>
  new CompositeDecorator([
    {
      strategy: findLinkEntities,
      component: Link,
    },
  ]);

export default createLinkDecorator;

export const onAddLink: any = (
  editorState: any,
  setEditorState: any,
  link: any
) => {
  const decorator = createLinkDecorator({});
  if (link) {
    if (true) {
      const currentContent = editorState.getCurrentContent();

      const entityKey = currentContent.getLastCreatedEntityKey();
      const selection = editorState.getSelection();
      const textWithEntity = Modifier.insertText(
        currentContent,
        selection,
        link,
        undefined,
        entityKey
      );
      const newState = EditorState.createWithContent(textWithEntity, decorator);
      setEditorState(newState);
    }
  }
};

interface IAddLinkPopUP {
  open: any;
  setOpen: any;
  editorState: any;
  setEditorState: () => void;
}

export const AddLinkPopUP: FunctionComponent<IAddLinkPopUP> = ({
  open,
  setOpen,
  editorState,
  setEditorState,
}) => {
  return (
    <>
      <button
        onClick={(e) => {
          e.stopPropagation();
          setOpen(true);
        }}
        key={0}
      >
        link
      </button>
      {open && (
        <AddLinkElement
          editorState={editorState}
          setEditorState={setEditorState}
          setOpen={setOpen}
        />
      )}
    </>
  );
};
const AddLinkElement = ({ editorState, setEditorState, setOpen }: any) => {
  const [linkTarget, setLinkTarget] = useState('');
  const isDisabled = useMemo(
    () => (linkTarget && linkTarget.includes(' ') ? true : false),
    [linkTarget]
  );
  return (
    <div onClick={(e) => e.stopPropagation()} className="rdw-link-modal">
      <label className="rdw-link-modal-label">Link Target</label>
      <input
        id="linkTarget"
        className="rdw-link-modal-input"
        name="linkTarget"
        value={linkTarget}
        onChange={(e) => setLinkTarget(e.target.value)}
      />
      <label className="rdw-link-modal-target-option">
        <input id="openLinkInNewWindow" type="checkbox" value="_blank" />
        <span>Open link in new window</span>
      </label>
      <span className="rdw-link-modal-buttonsection">
        <button
          className="rdw-link-modal-btn"
          disabled={isDisabled}
          onClick={() => {
            onAddLink(editorState, setEditorState, linkTarget);
            setOpen(false);
          }}
        >
          Add
        </button>
        <button
          onClick={() => {
            setOpen(false);
          }}
          className="rdw-link-modal-btn"
        >
          Cancel
        </button>
      </span>
    </div>
  );
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function checkURL(URL = '') {
  if (URL.match(detectUrl) && !URL.includes(' ')) {
    return true;
  } else {
    return false;
  }
}
